// @ngInject
function stateConfig($stateProvider) {
    $stateProvider.state('product.importfileslist',{
        url: '/importfileslist',
        views: {'wideColumnView@product': {
            templateUrl: 'main/product/importfileslist/importfileslist.tpl.html',
            controller: 'ImportFilesListController as vm'
        }}

    });
}

// @ngInject
function ImportFilesListController($state, loadSpinnerService, FileDataImportApiService, AuthService) {
    console.log("ImportFilesListController start");
    var vm = this;

    vm.currentPage = 1;
    vm.totalItems = 0;
    vm.itemsPerPage = 15;
    vm.loadImportFiles = loadImportFiles;

    vm.importFiles = [];

    vm.editImportFile = editImportFile;
    vm.deleteImportFile = deleteImportFile;
    vm.canAccess = AuthService.canAccess;

    activate();

    function activate() {
        loadImportFiles();
    }

    function loadImportFiles() {
        loadSpinnerService.start('mainSpinner');
        FileDataImportApiService.getImportFiles(vm.currentPage, vm.searchTerm, vm.itemsPerPage).then(function(response) {
            vm.totalItems = response.totalItems;
            vm.importFiles = response.data;
        }, function(error) {
            console.log(error);
        }).finally(function() {
            loadSpinnerService.stop('mainSpinner');
        });
    }

    function editImportFile(importFileId) {
        $state.go('product.importfileslist.importeditor', { importFileId: importFileId });
    }

    function deleteImportFile(importId) {
        loadSpinnerService.start('mainSpinner');
        FileDataImportApiService.deleteArticlesOrdersImportFile(importId).then(function() {
            var deletedItem = _.find(vm.importFiles, function(importFile) {
                return importFile.id === importId;
            });

            vm.importFiles = _.without(vm.importFiles, deletedItem);
        }, function(error) {
            console.log(error);
        }).finally(function() {
            loadSpinnerService.stop('mainSpinner');
        });
    }
}

angular
    .module('product.importfileslist', ['importfileslist.articleimport', 'importfileslist.importeditor'])
    .config(stateConfig)
    .controller('ImportFilesListController', ImportFilesListController);
